import React from 'react';
import { Type, Barcode, QrCode, Image as ImageIcon, Square, Minus, LucideIcon } from 'lucide-react';
import { LabelElementType } from '../../../../../types/labelDesign';

interface ElementToolboxProps {
  onAdd: (type: LabelElementType) => void;
}

const TOOLS: Array<{ type: LabelElementType; label: string; Icon: LucideIcon }> = [
  { type: 'Text', label: 'Tekst', Icon: Type },
  { type: 'Barcode', label: 'Strekkode', Icon: Barcode },
  { type: 'QrCode', label: 'QR-kode', Icon: QrCode },
  { type: 'Image', label: 'Bilde/logo', Icon: ImageIcon },
  { type: 'Rectangle', label: 'Rektangel', Icon: Square },
  { type: 'Line', label: 'Linje', Icon: Minus }
];

export const ElementToolbox: React.FC<ElementToolboxProps> = ({ onAdd }) => {
  return (
    <div className="flex flex-col gap-1 p-2 bg-[var(--color-surface)] border-r border-[var(--color-border)]">
      <div className="text-xs font-semibold text-[var(--color-text-secondary)] uppercase mb-1 px-1">
        Elementer
      </div>
      {TOOLS.map(({ type, label, Icon }) => (
        <button
          key={type}
          type="button"
          onClick={() => onAdd(type)}
          className="flex items-center gap-2 px-3 py-2 text-sm rounded hover:bg-[var(--color-surface-hover)] text-[var(--color-text-primary)] text-left w-40"
          title={`Legg til ${label.toLowerCase()}`}
        >
          <Icon size={16} />
          <span>{label}</span>
        </button>
      ))}
    </div>
  );
};
